// AUTO GENERATED FILE - Changes WILL be lost.
// cs - used as 'cs' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Sázkový tiket",
  "product.last60-row-single": "NBA Posledních 60 zápasů",
  "product.sb-english-single": "Anglický fotbalový sázkový tiket na jeden zápas",
  "product.sb-italian-single": "Italský Soccerbet Jednotlivé zápasy",
  "product.sb-greek-single": "Řecký Soccerbet Jednotlivé zápasy",
  "product.sb-english-league": "Anglická liga Soccerbet",
  "product.sb-italian-league": "Italská liga Soccerbet",
  "product.sb-greek-league": "Řecká liga Soccerbet",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Místo sázky",
  "betslip.clear": "Vymazat vše",
  "betslip.clearResult": "Přehledně",
  "betslip.noSelections": "Přidejte tipy a začněte sázet",
  "betslip.notLoggedIn": "Přihlaste se a začněte sázet",
  "betslip.refresh": "Obnovit",
  "betslip.totalStake": "Celkový podíl",
  "betslip.noHistoryData": "Informace o sázce nejsou k dispozici",
  "betslip.openBets": "Otevřené sázky",
  "betslip.betHistory": "Historie sázek",
  "betslip.betHistoryWon": "Won",
  "betslip.betHistoryLost": "Ztracené",
  "loading.loading": "Načítání",
  "loading.account": "Načítání účtu",
  "loading.league": "Načítání ligy",
  "loading.gameweeks": "Načítání týdnů hry",
  "loading.markets": "Načítací trhy",
  "loading.bethistory": "Načítání historie sázek",
  "login.loginRequired": "Vyžaduje se přihlášení",
  "login.loginToBet": "Pro zahájení sázení se prosím přihlaste",
  "navigation.back": "Zpět",
  "navigation.close": "Zavřít",
  "video.liveStreamAvailable": "K dispozici je živý přenos",
  "video.logInToWatch": "Pro sledování se prosím přihlaste",
  "error.error": "Chyba",
  "error.404": "Stránka nebyla nalezena",
  "error.gameLaunchFailed": "Nelze spustit hru",
  "error.unknownErrorCode": "Neznámá chyba: {code}",
  "error.minUnitStakeLimitExceeded": "Minimální vklad je {limit}",
  "error.maxUnitStakeLimitExceeded": "Maximální vklad je {limit}",
  "error.minTotalStakeLimitExceeded": "Minimální celkový vklad je {limit}",
  "error.maxTotalStakeLimitExceeded": "Maximální celkový vklad je {limit}",
  "error.stakeInvalidMultiple": "Podíl musí být násobkem {multiple}",
  "error.notPlaced": "Nebyl umístěn",
  "error.wagerDisallowed": "Zakázaná sázka",
  "error.errorEventIsOff": "Událost byla zahájena",
  "wagerType.Singles": "Jednotlivci",
  "wagerType.Doubles": "Čtyřhry",
  "wagerType.Trebles": "Trebles",
  "wagerType.Accumulator": "Akumulátor",
  "wagerType.Perm 4-Folds": "Perm 4-Folds",
  "wagerType.Perm 5-Folds": "Perm 5-Folds",
  "wagerType.Perm 6-Folds": "Perm 6-Folds",
  "wagerType.Perm 7-Folds": "Perm 7-Folds",
  "wagerType.Perm 8-Folds": "Perm 8-Folds",
  "wagerType.Perm 9-Folds": "Perm 9-skladů",
  "error.excess_bets": "Maximálně {limit} souběžných sázek na sázkovém kupónu; odstraňte prosím sázku.",
  "product.sb-turkish-league": "Turecká Soccerbet liga",
  "error.minBetslipLimitExceeded": "Minimální celkový vklad na sázkovém tiketu je {limit}.",
  "error.maxBetslipLimitExceeded": "Maximální celkový vklad na sázkovém tiketu je {limit}.",
  "error.exceededMaxPayout": "Maximální možná výhra je {limit}; snižte prosím svůj vklad.",
  "betslip.potentialReturns": "Potenciální výnosy",
  "betslip.taxDisclaimer": "Všechny vaše čisté výhry jsou zdaněny při vypořádání sázky. Výše daně se vypočítá v závislosti na potenciální výhře sázky.",
  "error.maintenanceEnabled": "Na serveru právě probíhá údržba",
  "error.internalError": "Interní chyba",
  "error.invalidSession": "Relace je neplatná",
  "error.accountDisabled": "Účet je zakázán",
  "error.invalidPlayerID": "Neplatné ID hráče",
  "error.insufficientBalance": "Nedostatečná rovnováha",
  "error.configError": "Chyba konfigurace",
  "error.betPlaceFailed": "Nepodařilo se uzavřít sázku",
  "error.invalidProductID": "Neplatné ID produktu",
  "error.playerReachedGamingLimits": "Hráč dosáhl limitů zodpovědného hraní",
  "error.gameCycleDoesNotExist": "Herní cyklus neexistuje",
  "error.betAmountLimitExceeded": "Překročení limitu potenciálních výher pro neověřené hráče",
  "betslip.netStake": "Čistý podíl",
  "betslip.tax": "Daň",
  "error.badReturns": "Potenciální výnosy jsou nižší než hrubý podíl",
  "betslip.taxDisclaimerPoland": "Výhry nad 2 280 PLN se snižují o 10 %.",
  "error.incompatibleVersion": "Nepodporovaná verze aplikace. Proveďte prosím aktualizaci.",
  "product.iihf-row-single": "Mistrovství světa IIHF",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Návrat k hráči",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Průměrná hodnota RTP v této hře je {limit}.",
  "error.betslipContainsInvalidOptions": "Sázkový tiket obsahuje červeně vyznačené neplatné možnosti",
  "product.sb-scottish-single": "Scottish Soccerbet Jednotlivé zápasy",
  "product.sb-spanish-single": "Španělský Soccerbet Jednotlivé zápasy",
  "product.sb-spanish-league": "Španělská liga Soccerbet",
  "iihf-row.team.CAN": "Kanada",
  "iihf-row.team.FIN": "Finsko",
  "iihf-row.team.RUS": "Rusko",
  "iihf-row.team.USA": "Spojené státy",
  "iihf-row.team.CZE": "Česko",
  "iihf-row.team.SWE": "Švédsko",
  "iihf-row.team.SVK": "Slovensko",
  "iihf-row.team.NOR": "Norsko",
  "iihf-row.team.DEN": "Dánsko",
  "abbr.iihf-row.team.CAN": "MŮŽE",
  "abbr.iihf-row.team.FIN": "PLOUTEV",
  "abbr.iihf-row.team.RUS": "RUS",
  "abbr.iihf-row.team.USA": "USA",
  "abbr.iihf-row.team.CZE": "CZE",
  "abbr.iihf-row.team.SWE": "JZ",
  "abbr.iihf-row.team.SVK": "SR",
  "abbr.iihf-row.team.NOR": "ANI",
  "abbr.iihf-row.team.DEN": "DOUPĚ",
  "event.Icematchresnt": "Výsledek zápasu (1X2) (základní hrací doba)",
  "event.Icematchresot": "Výsledek zápasu (1,2) (včetně prodloužení)",
  "event.Icebothteamstoscore": "Oba týmy skórují (základní hrací doba)",
  "event.Icecorrectscoreot": "Správný výsledek (včetně prodloužení)",
  "event.Iceexactgoalsot": "Přesné góly (včetně prodloužení)",
  "event.Icegamelines2nt": "Hrací čáry obousměrné (regulérní hrací doba)",
  "event.Icegamelines3nt": "Hrací čáry 3-way (základní hrací doba)",
  "event.Iceou2p5totalgoalsot": "Více než 2,5 gólů celkem (včetně prodloužení)",
  "event.Iceou3p5totalgoalsot": "Více než 3,5 gólů celkem (včetně prodloužení)",
  "event.Iceou4p5totalgoalsot": "Více než 4,5 gólů celkem (včetně prodloužení)",
  "event.Iceteamaexactgoalsot": "Přesné góly domácího týmu (včetně prodloužení)",
  "event.Iceteambexactgoalsot": "Přesné góly hostujícího týmu (včetně prodloužení)",
  "event.Icematchresou3p5totalgoalsnt": "Výsledek zápasu a více/méně než 3,5 gólu (základní hrací doba)",
  "event.Icematchresou3p5totalgoalsot": "Výsledek zápasu a více/méně než 3,5 gólu (včetně prodloužení)",
  "event.Icehighestscoreperiodnt": "Linie s nejvyšším skóre (základní hrací doba)",
  "event.Iceou25goalsteamateambot": "Více/Méně než 2,5 gólu domácího nebo hostujícího týmu (včetně prodloužení)",
  "event.Icefirstteamtoscore": "Který tým vstřelí první gól? (Včetně prodloužení)",
  "event.Iceteamtowinmostperiods": "Tým, který vyhraje nejvíce třetin (základní hrací doba)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3,5",
  "selection.A -3.0": "{home} -3,0",
  "selection.A -2.5": "{home} -2,5",
  "selection.A -2.0": "{home} -2.0",
  "selection.A -1.5": "{home} -1,5",
  "selection.A -1.0": "{home} -1,0",
  "selection.A +1.0": "{home} +1,0",
  "selection.A +1.5": "{home} +1,5",
  "selection.A +2.0": "{home} +2.0",
  "selection.A +2.5": "{home} +2,5",
  "selection.A +3.0": "{home} +3,0",
  "selection.A +3.5": "{home} +3,5",
  "selection.B -3.5": "{away} -3,5",
  "selection.B -3.0": "{away} -3.0",
  "selection.B -2.5": "{away} -2,5",
  "selection.B -2.0": "{away} -2.0",
  "selection.B -1.5": "{away} -1,5",
  "selection.B -1.0": "{away} -1,0",
  "selection.B +1.0": "{away} +1,0",
  "selection.B +1.5": "{away} +1,5",
  "selection.B +2.0": "{away} +2.0",
  "selection.B +2.5": "{away} +2,5",
  "selection.B +3.0": "{away} +3,0",
  "selection.B +3.5": "{away} +3,5",
  "selection.X -3.0": "X-3,0",
  "selection.X -2.0": "X-2,0",
  "selection.X -1.0": "X-1,0",
  "selection.X +1.0": "X +1,0",
  "selection.X +2.0": "X +2,0",
  "selection.X +3.0": "X +3,0",
  "selection.A & Over": "{home} a více",
  "selection.A & Under": "{home} a méně",
  "selection.X & Over": "X a více",
  "selection.X & Under": "X a méně",
  "selection.B & Over": "{away} a více",
  "selection.B & Under": "{away} a méně",
  "selection.A Over": "{home} Konec",
  "selection.A Under": "{home} Pod",
  "selection.B Over": "{away} Over",
  "selection.B Under": "{away} Pod"
}
